import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const RadioIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path d="M10 0C4.48714 0 0 4.48714 0 10C0 15.5129 4.48714 20 10 20C15.5129 20 20 15.5129 20 10C20 4.48714 15.5129 0 10 0ZM10 17.1429C6.06143 17.1429 2.85714 13.9386 2.85714 10C2.85714 6.06143 6.06143 2.85714 10 2.85714C13.9386 2.85714 17.1429 6.06143 17.1429 10C17.1429 13.9386 13.9386 17.1429 10 17.1429Z" />
    <path d="M10.0001 5.71436C7.67578 5.71436 5.71436 7.67578 5.71436 10.0001C5.71436 12.3244 7.67578 14.2858 10.0001 14.2858C12.3244 14.2858 14.2858 12.3244 14.2858 10.0001C14.2858 7.67578 12.3244 5.71436 10.0001 5.71436Z" />
  </SvgIcon>
);
